import React, { useEffect, useState } from 'react';

export default function TypewriterText({ text, speed = 120, pause = 2000, deleteSpeed = 60 }) {
  const [display, setDisplay] = useState('');

  useEffect(() => {
    let i = 0;
    let current = '';
    let timers = [];

    setDisplay('');

    const typeTimer = setInterval(() => {
      i++;
      current = text.slice(0, i);
      setDisplay(current);
      if (i >= text.length) {
        clearInterval(typeTimer);
        const pauseTimer = setTimeout(() => {
          const deleteTimer = setInterval(() => {
            i--;
            current = text.slice(0, i);
            setDisplay(current);
            if (i <= 0) {
              clearInterval(deleteTimer);
              setDisplay('');
            }
          }, deleteSpeed);
          timers.push(deleteTimer);
        }, pause);
        timers.push(pauseTimer);
      }
    }, speed);
    timers.push(typeTimer);

    return () => { timers.forEach(t => clearInterval(t) || clearTimeout(t)); };
  }, [text, speed, pause, deleteSpeed]);

  return (
    <span>
      {display}
      <span className="typewriter-cursor">|</span>
    </span>
  );
}
